import { Icon, IconProps } from '@toggle/design-system';
import { CatalystInsightCategory, CatalystSubcategories } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './CatalystInsightTooltip.styles';

export interface CatalystInsightTooltipProps {
  category: CatalystInsightCategory;
  subCategory?: CatalystSubcategories;
  iconProps: IconProps;
}

export const CatalystInsightTooltip = ({
  category,
  subCategory,
  iconProps,
}: CatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);

  return (
    <S.TooltipWrapper>
      <Icon {...iconProps} size={32} />
      <S.RightWrapper>
        <S.TitleLabel>
          {category === 'company'
            ? t('insights:catalyst.titleCompanyCatalyst')
            : t('insights:catalyst.titleMarketCatalyst')}
        </S.TitleLabel>
        <S.CategoryLabel>
          {subCategory
            ? /* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */
              t(`catalyst.subcategories.${subCategory}`)
            : null}
        </S.CategoryLabel>
      </S.RightWrapper>
    </S.TooltipWrapper>
  );
};
